"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryCode = exports.getLanguageCode = exports.getLocale = exports.getDefaultLocale = exports.getLocalesForDataCenter = exports.getDataCenter = exports.DEV = void 0;
var constants_1 = require("./constants");
exports.DEV = /^(stg|dev|sandbox|qa|demo)/;
var DEV_HOST = /.*(firebaseapp\.com|ngrok\.io|netlify\.app)/;
/**
 * Is a Dev based location (stg1, dev1, firebase, etc)
 */
var isDev = function (_a) {
    var _b = _a === void 0 ? window.location : _a, hostname = _b.hostname;
    return process.env.NODE_ENV === 'development' || DEV_HOST.test(hostname) || exports.DEV.test(hostname.split('.')[0]);
};
function getDataCenter(_a) {
    var _b = _a === void 0 ? window.location : _a, host = _b.host;
    if (!isDev()) {
        return Object.values(constants_1.DATA_CENTERS).find(function (dc) { return dc.prodHost === host; }) || constants_1.DATA_CENTERS.NA;
    }
    return Object.values(constants_1.DATA_CENTERS).find(function (dc) { return dc.devHost === host; }) || constants_1.DATA_CENTERS.NA;
}
exports.getDataCenter = getDataCenter;
function isValidInDataCenter(locale, dc) {
    var _a;
    if (dc === void 0) { dc = getDataCenter(); }
    if (!dc)
        return false;
    var dataCenterCode = typeof dc === 'string' ? dc : dc.code;
    var country = typeof locale === 'string' ? (_a = constants_1.LOCALES[locale]) === null || _a === void 0 ? void 0 : _a.country : locale.country;
    return (country === null || country === void 0 ? void 0 : country.dataCenter.code) === dataCenterCode;
}
function isDataCenterCode(maybeCode) {
    return typeof maybeCode === 'string' && Object.values(constants_1.DataCenterCode).includes(maybeCode);
}
/**
 * Gets all locales within the given data center
 */
function getLocalesForDataCenter(dc) {
    if (dc === void 0) { dc = getDataCenter(); }
    var dataCenterCode = isDataCenterCode(dc) ? dc : dc.code;
    return Object.values(constants_1.LOCALES).filter(function (locale) { return locale.country.dataCenter.code === dataCenterCode; });
}
exports.getLocalesForDataCenter = getLocalesForDataCenter;
/**
 * Given a data center and language will try and determine the best default locale.
 */
function getDefaultLocale(lang, dc) {
    if (lang === void 0) { lang = constants_1.LanguageCode.ENGLISH; }
    if (dc === void 0) { dc = getDataCenter(); }
    var dataCenterCode = typeof dc === 'string' ? dc : dc.code;
    var validLocales = getLocalesForDataCenter(dataCenterCode);
    var isDefaultDataCenter = isValidInDataCenter(constants_1.DEFAULT_LOCALE_CODE, dc);
    // Try to prioritize DEFAULT_LOCALE if it is the same language
    if (isDefaultDataCenter && constants_1.DEFAULT_LOCALE_CODE.startsWith(lang)) {
        return constants_1.DEFAULT_LOCALE;
    }
    // Get the first locale that includes this language
    var locale = validLocales.find(function (locale) { return locale.code.startsWith(lang.toLowerCase()); });
    return locale || validLocales[0] || constants_1.DEFAULT_LOCALE;
}
exports.getDefaultLocale = getDefaultLocale;
var getLocale = function (localeCode) {
    return constants_1.LOCALES[localeCode] || getDefaultLocale();
};
exports.getLocale = getLocale;
function getLanguageCode(locale) {
    var _a;
    if (typeof locale === 'string' && Object.values(constants_1.LanguageCode).includes(locale)) {
        return locale;
    }
    return typeof locale === 'string' ? (_a = constants_1.LOCALES[locale]) === null || _a === void 0 ? void 0 : _a.languageCode : locale === null || locale === void 0 ? void 0 : locale.languageCode;
}
exports.getLanguageCode = getLanguageCode;
function getCountryCode(locale) {
    var _a;
    if (typeof locale === 'string' && Object.values(constants_1.LanguageCode).includes(locale)) {
        // If it is JUST a language
        if (locale !== 'en' && process.env.NODE_ENV === 'development')
            console.error("Unable to retrieve the country from the language code '" + locale + "'");
        return constants_1.COUNTRIES.US.code;
    }
    var country = typeof locale === 'string' ? (_a = constants_1.LOCALES[locale]) === null || _a === void 0 ? void 0 : _a.country : locale === null || locale === void 0 ? void 0 : locale.country;
    return country === null || country === void 0 ? void 0 : country.code;
}
exports.getCountryCode = getCountryCode;
